// extracted by mini-css-extract-plugin
export default {"main":"SplitButton--main--Z5ZeH","dropdown":"SplitButton--dropdown---HTvd","splitButton":"SplitButton--splitButton--CF888","bp3-button":"SplitButton--bp3-button--FN7Db"};